var dropdown = document.querySelectorAll(".cheader-menu__dropdown .dropbtn");
var i;

for (i = 0; i < dropdown.length; i++) {
  dropdown[i].addEventListener("click", function (e) {
    e.currentTarget.classList.toggle("active");
    var dropdownContent = e.currentTarget.nextElementSibling;
    if (dropdownContent.style.display === "block") {
      dropdownContent.style.display = "none";
    } else {
      dropdownContent.style.display = "block";
    }
  });
}
